module.exports = __webpack_public_path__ + "img/rs.fa22f648.png";